








import { Component, Mixins, Prop } from "vue-property-decorator";
import { MovableTextBoxInputMethodOptionKinds } from "../../../../domain/document/inputMethodOptionKinds";
import { DisableableMixin } from "../../../system/mixins";
import MovableTextBoxObject from "../objects/MovableTextBoxObject.vue";
import MovableTextBoxInputMethodEditor from "../inputMethodEditors/MovableTextBoxInputMethodEditor.vue";

@Component({
  components: {
    MovableTextBoxInputMethodEditor,
  }
})
export default class MovableTextBoxBehaviorEditor extends Mixins(DisableableMixin) {
  @Prop()
  source: MovableTextBoxObject;

  get isVisible(): boolean {
    return this.source.inputMethodOptionKind !== MovableTextBoxInputMethodOptionKinds.Normal;
  }
}
